(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        $('form.ays-check').areYouSure();
        var isdirty = false;

        $('form.ays-check').on('dirty.areYouSure', function() {
            if (! isdirty) {
                $('a[href]').not($('a[href^=#]')).not($('a[href^=javascript]')).addClass('checkSave');
                isdirty = true;
            }
        });

        $(document).on('click','a.checkSave', function(e){
            e.preventDefault();
            var self = $(this);
            bootbox.confirm("Sunteti sigur ca parasiti aceasta pagina fara sa salvati ?", function(result) {
                if (result){
                    self.removeClass('checkSave');
                    $('form.ays-check').areYouSure({'silent':true});
                    window.location = self.attr('href');
                }else{
                    //e.preventDefault();
                }
            });
        });

    });


})(document, window, jQuery);